import type { FirebaseOptions } from 'firebase/app'

export const getFirebaseConfig = (): FirebaseOptions => {
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY?.trim(),
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID?.trim(),
    messagingSenderId:
      import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID?.trim(),
    appId: import.meta.env.VITE_FIREBASE_APP_ID?.trim(),
  }

  const missingFields = Object.entries(config)
    .filter(([, value]) => !value)
    .map(([key]) => key)

  if (missingFields.length > 0) {
    throw new Error(
      `Missing Firebase configuration: ${missingFields.join(', ')}`,
    )
  }

  return config
}
